export default "__VITE_ASSET__Cr2S5y3___"